httpVueLoader.register(Vue, 'components/contact.vue');
httpVueLoader.register(Vue, 'components/WB00255301_pingao/Wb00255301_pingao.vue');

const store = new Vuex.Store({
    state: {
        result: null,
    },
    mutations: {
        setData(state, payload) {
            state.result = payload;
        },
    },
    actions: {
        getData(context) {
            axios.get('db.json').then(res => {
                context.commit('setData', res.data);
            });
        },
    }
});

new Vue({
    el: 'main',
    computed: {
        result() {
            return store.state.result;
        },
    },
    created() {
        store.dispatch('getData');
    },
    mounted() {
        new WOW().init();
    },
});